import Arrow from "./IconTypes/Arrow";
import Chevron from "./IconTypes/Chevron";
import DiagonalArrow from "./IconTypes/DiagonalArrow";
import Facebook from "./IconTypes/Facebook";
import HoverArrow from "./IconTypes/HoverArrow";
import Instagram from "./IconTypes/Instagram";
import LinkedIn from "./IconTypes/LinkedIn";
import LogoSquares from "./IconTypes/LogoSquares";
import LogoText from "./IconTypes/LogoText";
import LogoWithText from "./IconTypes/LogoWithText";
import LongArrow from "./IconTypes/LongArrow";
import Play from "./IconTypes/PlayIcon";
import Plus from "./IconTypes/Plus";
import Quote from "./IconTypes/Quote";
import Search from "./IconTypes/Search";
import ThinHoverArrow from "./IconTypes/ThinHoverArrow";
import Twitter from "./IconTypes/Twitter";
import UploadCloud from "./IconTypes/UploadCloud";
import Youtube from "./IconTypes/Youtube";

const icons = {
  logoSquares: LogoSquares,
  logoText: LogoText,
  logoWithText: LogoWithText,
  facebook: Facebook,
  twitter: Twitter,
  linkedin: LinkedIn,
  instagram: Instagram,
  youtube: Youtube,
  arrow: Arrow,
  longArrow: LongArrow,
  quote: Quote,
  chevron: Chevron,
  hoverArrow: HoverArrow,
  plus: Plus,
  play: Play,
  diagonalArrow: DiagonalArrow,
  thinHoverArrow: ThinHoverArrow,
  search: Search,
  uploadCloud: UploadCloud,
};

export default function Icon({
  type,
  ...rest
}: {
  type: string;
  [key: string]: unknown;
}) {
  const IconComp = icons[type as keyof typeof icons];
  if (!type || !IconComp) return null;

  return <IconComp {...rest} />;
}
